var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-back",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fa fa-angle-double-left"}),_vm._v(" Back ")])}
var staticRenderFns = []

export { render, staticRenderFns }